import globalUseStyles from '../../../../styles/globalCustomStyles';

import { Card, Typography } from '@mui/material';
import { useRecordContext, useTranslate } from 'react-admin';
import InfoTooltipIcon from "../../../../assets/InfoTooltipIcon";
import CustomTooltip from '../../../aegeon/CustomTooltip';
import useQueryProvider from '../../../aegeon/query/useQueryProvider';
import SiteEnergeticPerformanceDPEGraph from './SiteEnergeticPerformanceDPEGraph';

const SiteEnergeticPerformanceDPE = (props) => {
  const globalClasses = globalUseStyles();
  const t = useTranslate();
  const { type, isGraph, data, isLoading, usage } = props;
  const record = useRecordContext(props);
  const siteId = record?.id;

  let { data: dpeTable } = useQueryProvider(
    'sites',
    {
      query_name: "getDpeTable",
      id: siteId,
      params: {
        type: usage
      },
    }
  );

  const title = t('sites.energetic_performance.' + type + '.title');
  const subtitle = t('sites.energetic_performance.' + type + '.subtitle');
  const tooltip_text = t('sites.energetic_performance.' + type + '.tooltip_text');

  return (
    <Card className={globalClasses.DetailCard}>
      <div className={globalClasses.energeticPerfsTitles}>
        <div className={globalClasses.DetailCardTableTitle}>
          <Typography variant="h8">{title}</Typography>
          <CustomTooltip title={tooltip_text} icon={<InfoTooltipIcon />} />
        </div>
        <div className={globalClasses.DetailCardTableSubtitle}>
          {subtitle}
          <br />
          {t('sites.energetic_performance.general.choose_dpe_usage') + t("sites.energetic_performance.general.usages." + usage)}
        </div>
      </div>
      <div className={globalClasses.DetailCardGraph} >
        <SiteEnergeticPerformanceDPEGraph type={type} data={data} isLoading={isLoading} dpeTable={dpeTable} />
      </div>
    </Card>
  )
};

export default SiteEnergeticPerformanceDPE;